import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscriber } from 'rxjs';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { RoleMenuApiService } from '../CommonController/roleMenu-api-service';
import { UserManagementApiService } from '../CommonController/userManagement-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';

@Component({
  selector: 'app-user-tab-page',
  templateUrl: './user-tab-page.component.html',
  styleUrls: ['./user-tab-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    CommonSearchComponent,
    CommonPaginationComponent,
    CommonDropdownSearchComponent,
    MatIcon,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    MatInput,
    MatError,
  ],
})
export class UserTabPageComponent implements OnInit {
  currentPage = 1;
  pageSize = 10;
  totalItems = 0;
  searchText = '';
  roleId = 0;
  listOfUser = [];

  viewType = 'List';
  viewedUserID = '';

  submitButton = true;
  updateButton = false;

  listOfRole: any[] = [];
  filteredListOfRoles: any[] = [];
  RoleListForAddUser: any[] = [];

  userForm!: FormGroup;
  loggedInUserId = '';
  myimage = '../../assets/profile.png';
  userRole = '';
  userPermissions: any[] = [];
  adminName = '';

  userUpdate = false;
  userDelete = true;

  viewUser = true;
  createUser = true;
  updateUsers = true;
  deleteUser = true;

  constructor(
    private formBuilder: FormBuilder,
    public userManagementApiService: UserManagementApiService,
    public commonApiService: CommonApiService,
    public roleMenuApiService: RoleMenuApiService,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setUserManagementForm();
    this.getRolesList();
    this.fetchUserList();
  }

  checkPermission() {
    this.viewType = 'List';
    this.submitButton = true;
    this.updateButton = false;
    this.userRole = sessionStorage.getItem('userRole') || '';
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId') || '';
    this.adminName = sessionStorage.getItem('userName') || '';

    const permissions = sessionStorage.getItem('userPermissions');
    this.userPermissions = permissions ? JSON.parse(permissions) : [];
    this.userPermissions.forEach((element: any) => {
      if (element.pageName === 'User Management' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'User Management' && element.create === false) {
        this.createUser = false;
      }
      if (element.pageName === 'User Management' && element.update === false) {
        this.updateUsers = false;
      }
      if (element.pageName === 'User Management' && element.delete === false) {
        this.deleteUser = false;
      }
    });
  }

  setUserManagementForm() {
    this.userForm = this.formBuilder.group({
      firstName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
        SharedValidators.maxLengthRequired(10),
      ]),
      lastName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
        SharedValidators.maxLengthRequired(10),
      ]),
      roleId: new FormControl('', [Validators.required]),
      userEmail: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.validEmail,
      ]),
      mobileNumber: new FormControl('', [
        SharedValidators.mobileNumberValidation,
      ]),
      status: new FormControl(
        'Active',
        SharedValidators.requiredAndNoEmptySpaces
      ),
      leadId: new FormControl(this.loggedInUserId),
      searchUser: new FormControl(''),
      adminName: new FormControl(
        this.adminName,
        SharedValidators.requiredAndNoEmptySpaces
      ),
      state: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      country: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      Image: '',
      createdAt: new Date(),
      updatedAt: new Date(),
    });

    this.myimage = '../../assets/profile.png';
  }

  validateForm() {
    if (this.userForm.invalid) {
      SharedValidators.markAllAsTouched(this.userForm);
      return;
    } else {
      this.addUser();
    }
  }

  validateFormUpdate() {
    if (this.userForm.invalid) {
      SharedValidators.markAllAsTouched(this.userForm);
      return;
    } else {
      this.updateUser();
    }
  }

  addUpdateDeleteUser() {
    this.viewType = 'Add';
    this.submitButton = true;
    this.updateButton = false;
    this.userDelete = false;
    this.userForm.reset();
    this.userForm.controls['adminName'].setValue(this.adminName);
    this.myimage = '../../assets/profile.png';
  }

  onBack(component: string) {
    this.viewType = component;
    this.fetchUserList();
  }

  addUser() {
    this.spinner.show();
    const payload = this.userForm.value;
    payload.image = this.myimage;
    payload.leadId = this.loggedInUserId;

    this.userManagementApiService.createUser(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.fetchUserList();
          this.addNew();
          this.ngOnInit();
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  fetchUserList() {
    this.spinner.show();
    this.userManagementApiService
      .getAllUser(
        this.currentPage - 1,
        this.pageSize,
        this.roleId,
        this.searchText,
        this.loggedInUserId
      )
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.listOfUser = res.data;
          this.totalItems = res.totalItems;
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.listOfUser = [];
          this.commonApiService.openSnackbar(ERROR.error.message);
        },
      });
  }

  getRolesList() {
    this.filteredListOfRoles = [];
    this.roleMenuApiService.getRole(0, 100, '', this.userRole).subscribe({
      next: (res) => {
        this.listOfRole = res.data;

        const loggedInRole = this.userRole?.toLowerCase();

        this.RoleListForAddUser = this.listOfRole.filter((role: any) => {
          const currentRole = role.userRole?.toLowerCase();

          if (loggedInRole === 'super admin' && currentRole === 'super admin') {
            return false;
          }

          if (
            loggedInRole === 'admin' &&
            (currentRole === 'admin' || currentRole === 'super admin')
          ) {
            return false;
          }

          return true;
        });
        this.filteredListOfRoles = this.listOfRole.slice();

        this.filteredListOfRoles.unshift({
          roleId: 0,
          userRole: 'All',
          roleType: 'All',
          hierarchyLevel: 0,
          createdAt: '2024-12-17 16:39:38',
          rolePermissionResDtos: null,
        });
        this.filteredListOfRoles = this.filteredListOfRoles.map((item) => {
          return {
            key: item.userRole,
            value: item.roleId,
          };
        });
      },
      error: (ERROR: HttpErrorResponse) => {
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  fetchDataById(id: string) {
    this.spinner.show();
    this.getRolesList();
    this.userUpdate = true;
    this.viewType = 'Add';
    this.viewedUserID = id;
    this.userManagementApiService.getSingleUser(id).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.submitButton = false;
          this.updateButton = true;
          const data = res.data;
          this.userForm = this.formBuilder.group({
            firstName: new FormControl(data.firstName, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.nonNumericNoSpecialChars,
              SharedValidators.maxLengthRequired(30),
            ]),
            lastName: new FormControl(data.lastName, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.nonNumericNoSpecialChars,
              SharedValidators.maxLengthRequired(30),
            ]),
            roleId: new FormControl(data.roleId, [Validators.required]),
            userEmail: new FormControl(data.userEmail, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.validEmail,
            ]),
            mobileNumber: new FormControl(
              data.mobileNumber,
              SharedValidators.mobileNumberValidation
            ),
            searchUser: new FormControl(''),
            adminName: new FormControl(
              data.adminName ? data.adminName : '-',
              SharedValidators.requiredAndNoEmptySpaces
            ),
            status: new FormControl(
              data.status,
              SharedValidators.requiredAndNoEmptySpaces
            ),
            state: new FormControl(data.state, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.nonNumericNoSpecialChars,
              SharedValidators.maxLengthRequired(30),
            ]),
            country: new FormControl(data.country, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.nonNumericNoSpecialChars,
              SharedValidators.maxLengthRequired(10),
            ]),
            Image: '',
            leadId: data.leadId,
            id: id,
            updatedAt: new Date(),
          });
          this.myimage =
            data.image != null ? data.image : '../../assets/profile.png';
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  updateUser() {
    this.spinner.show();
    const payload = this.userForm.value;
    payload.image = this.myimage;
    payload.leadId = this.loggedInUserId;
    this.userManagementApiService.updateUser(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.updateButton = false;
          this.submitButton = true;
          this.fetchUserList();
          this.addNew();
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  addNew() {
    this.userForm.reset();
    this.ngOnInit();
    this.updateButton = false;
    this.submitButton = true;
  }

  onPageChange(event: number) {
    this.currentPage = event;
    this.fetchUserList();
  }

  onSizeChange(pageSize: number): void {
    this.pageSize = pageSize; // Update the pageSize
    this.currentPage = 1; // Reset to the first currentPage
    this.fetchUserList();
  }

  onSearchUsername(event: string) {
    this.searchText = event;
    this.currentPage = 1;
    this.fetchUserList();
  }

  onChange($event: Event) {
    const file = ($event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    const fileName = file.name;
    if (file.size >= 2 * 1024 * 1024) {
      this.commonApiService.openSnackbar('Max upload size allowed is 2mb');
    } else {
      const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
      if (
        ext.toLowerCase() === 'png' ||
        ext.toLowerCase() === 'jpg' ||
        ext.toLowerCase() === 'jpeg'
      ) {
        this.convertToBase64(file);
      }
    }
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<string>) => {
      this.readFile(file, subscriber);
    });
    observable.subscribe((d) => {
      this.myimage = d;
    });
  }

  readFile(file: File, subscriber: Subscriber<string | null>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      const result = fileReader.result;
      if (typeof result === 'string') {
        // Type guard
        subscriber.next(result);
      } else {
        subscriber.error(new Error('File could not be read as a string.'));
      }
      subscriber.complete();
    };

    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  delete(id: string) {
    if (confirm('Do you want to delete this user?')) {
      this.userManagementApiService.deleteUser(id).subscribe((res) => {
        this.commonApiService.openSnackbar(res.message);
        this.ngOnInit();
      });
    }
  }

  onRoleSelected(event: number): void {
    this.roleId = event;
    this.currentPage = 1;
    this.fetchUserList();
  }

  onRefresh() {
    if (this.submitButton) {
      this.userForm.reset();
      this.userForm.controls['adminName'].setValue(this.adminName);
      this.myimage = '';
    }
    if (this.updateButton) {
      this.fetchDataById(this.viewedUserID);
    }
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
